import React from 'react';

import RolloverController from './RolloverController';
import ResultRollover from './ResultRollover';

export default class ResultLink extends React.Component {
    constructor(props) {
        super(props);
        const { rolloverDirection } = this.props;
        this.controller = new RolloverController(this, rolloverDirection || 'left', 350);
        this.state = this.controller.getInitialState();
        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onMouseLeave = this._onMouseLeave.bind(this);
    }

    _onMouseEnter() {
        this.controller.onMouseEnter(`/api/results/${this.props.fixture.mid}/summary`);
    }

    _onMouseLeave() {
        this.controller.onMouseLeave();
    }

    render() {
        const { fixture, norollover, children } = this.props;
        let rollover;
        if (!norollover && this.state.rollover) {
            rollover = (
                <ResultRollover
                    mid={fixture.mid}
                    data={this.state.data}
                    onMouseEnter={this._onMouseEnter}
                    onMouseLeave={this._onMouseLeave}
                    directionInfo={this.controller.directionInfo}
                />
            );
        }
        let resultClass = 'cc-result-link';
        if (fixture.result) {
            resultClass += ` cc-result-${fixture.result.toLowerCase().replace(' ', '_')}`;
        }
        const href = `/results/${fixture.mid}`;
        let contents = children;
        if (!contents) {
            contents = fixture.details;
        }
        return (
            <div ref="element" className="cc-result">
                {rollover}
                <a className={resultClass} href={href} onMouseEnter={this._onMouseEnter} onMouseLeave={this._onMouseLeave}>
                    {contents}
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ResultLink.jsx